import { z } from "zod"

export function getClientCookie(name: string) {
    return document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith(`${name}=`))
        ?.split("=")[1]
}

export function setClientCookie(name: string, value: string) {
    document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * 365}`
}

export const FILTERS_ACCORDIONS_STATE_COOKIE_NAME = "filters-accordions-state"

export const FiltersAccordionsEnum = {
    PRICE: "price",
    CATEGORIES: "categories",
    SIZES: "sizes",
    TAGS: "tags",
} as const satisfies Record<string, string>

export const FiltersAccordionsStateSchema = z.object({
    [FiltersAccordionsEnum.PRICE]: z.boolean(),
    [FiltersAccordionsEnum.CATEGORIES]: z.boolean(),
    [FiltersAccordionsEnum.SIZES]: z.boolean(),
    [FiltersAccordionsEnum.TAGS]: z.boolean(),
})

export type FiltersAccordionsState = z.infer<
    typeof FiltersAccordionsStateSchema
>

export function setClientFiltersAccordionsState(state: FiltersAccordionsState) {
    setClientCookie(FILTERS_ACCORDIONS_STATE_COOKIE_NAME, JSON.stringify(state))
}

export const SELECTED_PRODUCT_VARIANT_INDEX_COOKIE_NAME =
    "selected-product-variants"

export const SelectedProductVariantsSchema = z.record(z.number())

export type SelectedProductVariants = z.infer<
    typeof SelectedProductVariantsSchema
>

export function setClientSelectedProductVariantIndexCookie(
    productHandle: string,
    index: number,
) {
    const currentCookie = getClientCookie(
        SELECTED_PRODUCT_VARIANT_INDEX_COOKIE_NAME,
    )
    const currentVariants: SelectedProductVariants = currentCookie
        ? JSON.parse(currentCookie)
        : {}

    currentVariants[productHandle] = index
    setClientCookie(
        SELECTED_PRODUCT_VARIANT_INDEX_COOKIE_NAME,
        JSON.stringify(currentVariants),
    )
}

export function getClientSelectedProductVariantIndexCookie(
    productHandle: string,
) {
    const cookie = getClientCookie(SELECTED_PRODUCT_VARIANT_INDEX_COOKIE_NAME)
    if (!cookie) return null

    const variants = JSON.parse(cookie) as SelectedProductVariants
    return variants[productHandle] ?? null
}
